import axios from 'axios';

const ax = axios.create();
ax.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export function getGradeMap() {
  return ax.get('/api/grades/mapping');
}

